<template>
	<div id="" ref="">
		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('硬件编码')}}</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="devHdcode" disabled=true>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('设备型号')}}</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="devSerialno" ref="idSerialNo"><div style="float:left; width:16px; height:30px; border:0px solid red; text-align:center; line-height:34px; color:red;">*</div>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('设备名称')}}</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="devName"><div style="float:left; width:16px; height:30px; border:0px solid red; text-align:center; line-height:34px; color:red;">*</div>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('有效期至')}}</div>
			<input type="text" style="width:240px;" maxlength="10" v-model="devValidate" ref="idValidate">
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('设备状态')}}</div>
			<cselect style="position:relative; height:30px; min-width:150px; z-index:999;" :defv="devSts" v-model="devSts" :ctrl="ctrlDevSts" :csData="dataDevSts"></cselect>
		</div>

		<!--div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('授权方式')}}</div>
			<cselect style="position:relative; height:30px; min-width:150px; z-index:997;" :defv="devAuthType" v-model="devAuthType" :ctrl="ctrlAuthType" :csData="dataAuthType"></cselect>
		</div-->

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('设备锁定')}}</div>
			<radio ref="idLock1" style="height:30px; margin-right:20px;" v-model="devLock" :size="18" :root="{obj:this}" :grpName="'DevLock'" :val="1" :capt="getLangText('是')"></radio>
			<radio ref="idLock0" style="height:30px; margin-right:20px;" v-model="devLock" :size="18" :root="{obj:this}" :grpName="'DevLock'" :val="0" :capt="getLangText('否')"></radio>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('支持离线')}}</div>
			<radio ref="idMode1" style="height:30px; margin-right:20px;" v-model="devMode" :size="18" :root="{obj:this}" :grpName="'DevMode'" :val="1" :capt="getLangText('是')"></radio>
			<radio ref="idMode0" style="height:30px; margin-right:20px;" v-model="devMode" :size="18" :root="{obj:this}" :grpName="'DevMode'" :val="0" :capt="getLangText('否')"></radio>
		</div>

		<!--div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('权益等级')}}</div>
			<cselect style="position:relative; height:30px; min-width:150px; z-index:997;" :defv="equityLevel" v-model="equityLevel" :ctrl="ctrlEquityLevel" :csData="dataEquityLevel"></cselect>
		</div-->

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('设备定位')}}</div>
			<input type="text" style="width:240px;" maxlength="40" v-model="devLocate">
		</div>

		<div style="float:left; width:100%; height:40px; border:0px solid red; margin-top:10px;">
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-left:50px;" @click="onCancelClick">{{getLangText("取消")}}</div>
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-right:50px; float:right;" @click="onOKClick">{{getLangText("确定")}}</div>
		</div>
	</div>
</template>

<script>

import cselect    from '../cf/cselect'
import radio      from '../cf/cradio'

export default {
	name: 'devInfo',
	components:{
		cselect, radio
	},
	data () {
		return {
			devId: "",
			devHdcode: "",
			devSerialno: "soft",
			devName: "",
			devValidate: "",
			//devAuthType: 110,                      // 授权类型
			devLocate: "",
			/*ctrlAuthType:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},*/
			equityLevel: 130,                    // 权益等级
			/*ctrlEquityLevel:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10,
				Removefirst: true
			},*/
			devSts: 130,                    // 设备状态
			ctrlDevSts:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10,
				Removefirst: true
			},
			devLock: 0,
			devMode: 1,
			tmId: 0,
			tmName: "",
		}
	},
	mounted: function(){
		this.devId         = this.$route.query.devId;
		this.devHdcode     = this.$route.query.devHdcode;
		this.devSerialno   = this.$route.query.devSerialno;
		this.devValidate   = this.$route.query.devValidate;
		this.devSts        = this.$route.query.devSts;
		this.devName       = this.$route.query.devName;
		//this.devAuthType   = this.$route.query.devAuthType;
		this.equityLevel   = this.$route.query.devEquityLevel;
		this.devLocate     = this.$route.query.devLocate;
		this.devLock       = this.$route.query.deviceLock;
		this.devMode       = this.$route.query.deviceMode;

		//if( this.devLock != 1 ) this.devLock = 0;
		this.$refs["idLock"+this.devLock].setChecked( true );
		this.$refs["idMode"+this.devMode].setChecked( true );

		if( this.$route.query.devCustId == gPlatCustId && this.login.userId == gPlatUserId )
			;
		else  // 非平台管理员不允许修改设备权限及配置信息
		{
			this.$refs["idSerialNo"].disabled = true;
			this.$refs["idValidate"].disabled = true;
			//this.ctrlAuthType.self.setDisabled( true );
			//this.ctrlEquityLevel.self.setDisabled( true );
			this.ctrlDevSts.self.setDisabled( true );
		}
	},
	computed:{

	},
	methods:{
		onCancelClick: function(){
			this.$parent.onPopWinClose( );
		},
		onDeviceSerialFocus:function(){
			this.$refs["idSerialNo"].focus();
		},
		onDeviceNameFocus:function(){
			this.$refs["devName"].focus();
		},
		onOKClick: function( ){
			if( this.devSerialno=="" )
			{
				this.appRoot.app.showDlgCfm( this.DialogType.Err, LangText("错误"), LangText("请输入设备型号"), "", {okFunc:this.onDeviceSerialFocus, okParam:null} );
				return;
			}
			if( this.devName=="" )
			{
				this.appRoot.app.showDlgCfm( this.DialogType.Err, LangText("错误"), LangText("请输入设备名称"), "", {okFunc:this.onDeviceNameFocus, okParam:null} );
				return;
			}

			let body={ devId: this.devId, devEquityLevel: parseInt(this.equityLevel), devSerialno: this.devSerialno,
						devAuthType: 110/*parseInt(this.devAuthType)*/, devSts: parseInt(this.devSts),
						deviceLock: parseInt(this.devLock), deviceMode: parseInt(this.devMode),
						devLocate: this.devLocate, devValidate: parseInt(this.devValidate), devName: this.devName };
			this.doTrade( "POST", ServAddr+"/api/device/devEdit", this.onAddOK, true, body, null );
		},
		onAddOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			this.$parent.onPopWinClose2();
			if( data.code == 200 )
				 this.appRoot.app.showDlgTip( 1200, LangText("保存成功"), this.CLR.Suc, this.$parent.onPopWinClose, true );
			else this.appRoot.app.showDlgTip( 1200, LangText("保存失败"), this.CLR.Err, this.$parent.onPopWinClose, true );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// devInfo.vue?1b1a059a